import { useState, useContext, useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'

// Context
import { NavigationContext } from '../../context/NavigationContext'
import { CalendarContext } from '../../context/CalendarContext'

// Internal components
import Svg from '../Svg/Svg'
import { UserContext } from '../../context/UserContext'

const ToastMessage = () => {
  // Context
  const navigationContext = useContext(NavigationContext)
  const calendarContext = useContext(CalendarContext)
  const userContext = useContext(UserContext)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  const toastShownDuration = 5000

  const [showToastMessage, setShowToastMessage] = useState(false)
  const [fadeToastMessage, setFadeToastMessage] = useState(false)
  const [toastMessage, setToastMessage] = useState(false)
  const [toastLink, setToastLink] = useState({})

  const createMarkup = (text) => ({ __html: text })

  useEffect(() => {
    if (navigationContext.toastMessage.message) {
      setToastMessage(
        navigationContext.toastMessage.vars
          ? t(navigationContext.toastMessage.message, navigationContext.toastMessage.vars)
          : t(navigationContext.toastMessage.message)
      )
      setToastLink(navigationContext.toastMessage.link)
      setFadeToastMessage(false)
      setShowToastMessage(true)

      if (navigationContext.toastMessage.scrollToDate) {
        calendarContext.setIndicatorDate(navigationContext.toastMessage.date)
        calendarContext.setScrollToast(true)
      }

      setTimeout(() => removeToastMessage(), toastShownDuration)
    } else {
      setToastMessage(false)
      setToastLink({})
      setShowToastMessage(false)
    }
  }, [navigationContext.toastMessage])

  const removeToastMessage = () => {
    setFadeToastMessage(true)
    calendarContext.setScrollToast(false)
    setTimeout(() => navigationContext.setToastMessage(false), toastShownDuration)
  }

  return (
    <>
      {showToastMessage && (
        <div
          className={`ToastMessage${showToastMessage && toastMessage.length ? ' is-shown' : ''}${
            fadeToastMessage ? ' is-faded' : ''
          }`}
        >
          <div className="ToastMessage-content">
            {toastMessage.length && (
              <>
                <p className="ToastMessage-copy">
                  <>
                    {toastMessage && (
                      <span className="ToastMessage-text" dangerouslySetInnerHTML={createMarkup(toastMessage)}></span>
                    )}
                    {toastLink && (
                      <>
                        <Link href={toastLink?.href}>
                          <a className="ToastMessage-link">{toastLink?.label}</a>
                        </Link>
                      </>
                    )}
                  </>
                </p>
                <button className="ToastMessage-closeButton" onClick={() => setShowToastMessage(false)}>
                  <Svg id={'icon-close'} modifiers={['ToastMessage-closeIcon']} />
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default ToastMessage
